import React from "react";
import WidgetCard from "./WidgetCard";
import { Col, Row } from "antd";
import { BsArrowRight } from "react-icons/bs";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import wordcloudInit from "highcharts/modules/wordcloud";
import { WordCloudsWidgetProps } from "@ts/common-types";

if (typeof Highcharts === "object") {
    wordcloudInit(Highcharts);
}

const WordCloudsWidget: React.FC<WordCloudsWidgetProps> = ({ title, type, widgetData, onClickMoreHandler }) => {
    const getChartOptions = () => ({
        chart: {
            type: "wordcloud",
        },
        title: {
            text: "",
        },
        series: [
            {
                type: "wordcloud",
                data: widgetData,
                colors:
                    type === "positive"
                        ? ["#28a745", "#34d058", "#78c850", "#a3e635"]
                        : ["#dc3545", "#e55353", "#f85149", "#fa5252"],
            },
        ],
        credits: {
            enabled: false,
        },
    });

    return (
        <WidgetCard className="my-4">
            <Row className="mb-3" justify="space-between" align="middle">
                <Col>
                    <h5>{title || "Ratings and Reviews Trends"}</h5>
                </Col>
                <Col className="ms-4">
                    <span
                        role="button"
                        className="link-primary link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover small"
                        onClick={()=>onClickMoreHandler(type)}
                    >
                        More <BsArrowRight />
                    </span>
                </Col>
            </Row>
            <Row className="d-flex w-100">
                <Col span={24}>
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={getChartOptions()}
                    />
                </Col>
            </Row>
        </WidgetCard>
    );
};

export default WordCloudsWidget;